import Users from './AdminUsersPage';
import Clients from './AdminClientsPage';
import CreateUser from 'src/components/admin/sections/AdminCreateUserPage';
import Offices from './AdminOfficesPage';
import Roles from './RoleManagementPage';

export default {
    Users,
    Clients,
    CreateUser,
    Offices,
    Roles,
};



// WEBPACK FOOTER //
// ./src/components/admin/sections/index.ts